function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";

// Customizable Area Start
import { StyleSheet, Text, View, TextInput, Button, ScrollView, TouchableWithoutFeedback, Platform } from "react-native";
// Customizable Area End

import OTPInputAuthController from "./OTPInputAuthController";
export default class OTPInputAuth extends OTPInputAuthController {
  constructor(props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }
  render() {
    return (
      /*#__PURE__*/
      //Merge Engine DefaultContainer
      React.createElement(ScrollView, {
        keyboardShouldPersistTaps: "always",
        style: styles.container
      }, /*#__PURE__*/React.createElement(TouchableWithoutFeedback, {
        onPress: () => {
          this.hideKeyboard();
        }
      }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
        style: styles.titleWhySignUp //UI Engine::From Sketch
      }, this.state.labelInfo, " "), /*#__PURE__*/React.createElement(TextInput, _extends({
        testID: "txtMobilePhoneOTP" //Merge Engine::From BDS of Parent <See Forgot Password and Mobile Account Regitration>
        ,
        style: Platform.OS === "web" ? styles.phoneInputWeb //UI Engine::From Sketch
        : styles.phoneInputMobile //UI Engine::From Sketch
        ,
        placeholder: this.placeHolderOtp //UI Engine::From Sketch
      }, this.txtMobilePhoneOTPProps)), /*#__PURE__*/React.createElement(Button, _extends({
        testID: "btnSubmitOTP" //Merge Engine::From BDS <See Forgot Password and Mobile Account Regitration>
        ,
        title: this.btnTxtSubmitOtp //UI Engine::From Sketch
        ,
        color: this.submitButtonColor //UI Engine::From Sketch
      }, this.btnSubmitOTPProps)))))
    );
  }
}

// Customizable Area Start
const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    width: Platform.OS === "web" ? "75%" : "100%",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: 650,
    backgroundColor: "#fff"
  },
  titleWhySignUp: {
    marginBottom: 32,
    fontSize: 16,
    textAlign: "left",
    marginVertical: 8
  },
  titleOtpInfo: {
    marginBottom: 32,
    fontSize: 16,
    textAlign: "left",
    marginVertical: 8
  },
  phoneInputMobile: {
    flexDirection: "row",
    fontSize: 16,
    textAlign: "left",
    backgroundColor: "#00000000",
    marginBottom: 64,
    borderWidth: 1,
    borderColor: "#767676",
    borderRadius: 2,
    includeFontPadding: true,
    padding: 10
  },
  phoneInputWeb: {
    flex: 1,
    flexDirection: "row",
    marginBottom: 64,
    fontSize: 18,
    padding: 10,
    borderBottomColor: "#767676",
    borderBottomWidth: 1
  },
  bgRectBorder: {
    borderWidth: 1,
    borderColor: "#767676",
    borderRadius: 2,
    marginBottom: 10,
    padding: 10
  }
});
// Customizable Area End